module.exports = __webpack_public_path__ + "img/Edit-assumptions.37e36f84.svg";